import { CSSProperties } from "@material-ui/core/styles/withStyles";

// img
import { constructionBlockSvg } from "@img/illustrations";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

// components
import {
  standardStyles,
  tipStyles,
} from "@components/suggestion-card-header/SuggestionCardHeader.styles";

////////////////////////////////////////
// #region

///////////////////////
// Shared Tip Styles //
///////////////////////

const { container, body, topLine } = standardStyles;
const { tipHeader, tipBody, tipSubHeading, headerColor, tipBanner: standardTipBanner } = tipStyles;

export { container, body, headerColor, tipHeader, tipSubHeading, tipBody, topLine };

///////////////////
// Custom Styles //
///////////////////

export const tipBanner: CSSProperties = {
  ...standardTipBanner,
  background: `#89c6a9 url(${constructionBlockSvg}) center / 100px no-repeat`,
  width: "100%",
  height: 120,
};

export const row: CSSProperties = {
  display: "flex",
  marginBottom: 5,
  alignItems: "center",
  justifyContent: "center",
};

export const number: CSSProperties = {
  width: 20,
  minWidth: 20,
  fontWeight: 600,
};

export const explainer: CSSProperties = {
  marginTop: 10,
  marginBottom: 0,
};

export const cardButtonContainer: CSSProperties = {
  padding: 6,
  borderTop: `1px solid ${greys.borderGrey}`,
};
